import * as React from 'react';
import UILessDialogWrapper from './UILessDialogWrapper';
import UILessFrame from './UILessFrame';
import { AddinCommand, getExtensibilityState } from 'owa-addins-store';
import { ObservableMap } from 'mobx';
import { observer } from 'mobx-react';

@observer
export default class UILessAddinCommandsComponent extends React.Component<{}, {}> {
    render(): JSX.Element {
        const items: JSX.Element[] = [];

        getExtensibilityState().runningUILessAddinCommands.forEach(
            (uiLessAddins: ObservableMap<string, AddinCommand>, hostItemIndex: string) => {
                uiLessAddins.forEach((addinCommand: AddinCommand, controlId: string) => {
                    items.push(
                        <UILessDialogWrapper
                            hostItemIndex={hostItemIndex}
                            controlId={controlId}
                            addinCommand={addinCommand}
                            key={controlId}>
                            <UILessFrame
                                addinCommand={addinCommand}
                                controlId={controlId}
                                hostItemIndex={hostItemIndex}
                            />
                        </UILessDialogWrapper>
                    );
                });
            }
        );
        return <div>{items}</div>;
    }
}
